import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useI18n } from "../lib/i18n";
import { useSettings } from "../lib/settings";
import { Link } from "react-router-dom";
import { useAutoTranslate, T } from "../lib/autoTranslate";

const FAQItem = ({ q, a, i }) => {
  const question = useAutoTranslate(q);
  const answer = useAutoTranslate(a);
  return (
    <AccordionItem value={`item-${i}`} className="border-b border-[var(--ri-border)]">
      <AccordionTrigger className="text-left font-serif-display text-[19px] md:text-[22px] py-5 hover:no-underline">
        {question}
      </AccordionTrigger>
      <AccordionContent className="text-[15.5px] leading-[1.75] text-[var(--ri-ink-soft)] pb-6">
        {answer}
      </AccordionContent>
    </AccordionItem>
  );
};

const FAQ = () => {
  const { t } = useI18n();
  const { settings } = useSettings();
  const s = settings || {};
  const items = s.faqs || [];

  return (
    <section id="faq" className="section bg-[var(--ri-cream)]">
      <div className="container-x">
        <div className="divider mb-14" />
        <div className="grid lg:grid-cols-[360px_1fr] gap-12">
          <div>
            <p className="eyebrow mb-3"><T>{s.faq_eyebrow || t("faq_eyebrow")}</T></p>
            <h2 className="font-serif-display text-[34px] md:text-[42px] leading-[1.08]"><T>{s.faq_title || t("faq_title")}</T></h2>
            <p className="mt-4 text-[15px] text-[var(--ri-muted)] leading-[1.7]">
              Didn't find your answer? <Link to="/contact" className="text-[var(--ri-red)] link-underline">Contact us</Link>. We reply within a day.
            </p>
          </div>
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <FAQItem key={i} q={f.q} a={f.a} i={i} />
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
